import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { AbstractTypeMediaData, AbstractTypeMediaSchema } from ".";

export interface ComposeUploadsData {
    abstractId: number;
    typeMedia: AbstractTypeMediaData[];
}

export class ComposeUploads implements FormValidationModel<ComposeUploadsData> {
    public data: ComposeUploadsData;
    public rules: yup.Schema<ComposeUploadsData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            typeMedia: [],
        };
        this.rules = yup.object<ComposeUploadsData>().shape({
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            typeMedia: yup.array().of(AbstractTypeMediaSchema).label("Media categories"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/abstract/ComposeUploads.ts